import { render, staticRenderFns } from "./ClientClickEventsModalContainer.vue?vue&type=template&id=6cbda1f6&scoped=true&"
import script from "./ClientClickEventsModalContainer.vue?vue&type=script&lang=js&"
export * from "./ClientClickEventsModalContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbda1f6",
  null
  
)

export default component.exports